import { createFileRoute } from '@tanstack/react-router';

import { LanguageSelectionStep } from '@/features/workspace/ui/language-select-step';
import { REDIRECT_PAGE } from '@/shared/redirect/constants';
import z from 'zod';

const searchParams = z.object({
  redirectPage: z.enum(REDIRECT_PAGE).optional(),
});

export const Route = createFileRoute('/workspace/create/language')({
  validateSearch: searchParams,
  component: LanguageSelectionStep,
});
